import {
  createComponentMapperModel,
  withCompInfo,
} from '@wix/editor-elements-integrations';
import {
  props,
  css,
  sdkData,
} from '../../../StylableButton/viewer/StylableButton.mapper';
import { OPEN_BUTTON_TYPE } from '../../consts';

export const structure = withCompInfo<any, any>()(
  ['structure'],
  ({ structure: structureObject }) => {
    return {
      [structureObject.id]: {
        ...structureObject,
        componentType: 'StylableButton',
        metaData: { originalComponentType: OPEN_BUTTON_TYPE },
      },
    };
  },
);

export default createComponentMapperModel({
  structure,
  props,
  css,
  sdkData,
});
